





































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListShiiresaki from '@/components/common/search/ListShiiresaki.vue';
import { API_SEARCH_SHIIRESAKI } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlShiiresaki',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListShiiresaki,
  },
  props: {
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '仕入先',
    },
    widthCd: {
      type: Number,
      default: 84,
    },
    widthName: {
      type: Number,
      default: 340,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    targetYmd: {
      type: Number,
      required: true,
    },
    shiiresakiKb: {
      type: Number,
    },
    shiharaisakiKb: {
      type: Number,
    },
    soshikiCd: {
      type: Number,
    },
    gyoshuCd: {
      type: Number,
    },
    mukoUmuFlg: {
      type: Number,
    },
    tokenCheckFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_SHIIRESAKI,
    ListShiiresakiShow: false,
    mounted: false,
    shiiresakiCd: 0,
    shiiresakiRyakuMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { shiiresakiCd, shiiresakiRyakuMei } = item;
      console.log(shiiresakiCd);
      this.shiiresakiCd = shiiresakiCd;
      this.shiiresakiRyakuMei = shiiresakiRyakuMei;
      this.ListShiiresakiShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.ListShiiresakiShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    async handleChange(value: number) {
      if (!this.mounted) return;
      this.shiiresakiCd = value;
      if (value) {
        await this.getShiiresakiItem();
      } else {
        this.shiiresakiRyakuMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk && this.callbackOk({ shiiresakiCd: this.shiiresakiCd });
      }
    },
    async getShiiresakiItem() {
      const res = await axios.get(API_SEARCH_SHIIRESAKI, {
        params: {
          shiiresakiCd: this.shiiresakiCd,
          targetYmd: this.targetYmd,
          shiiresakiKb: this.shiiresakiKb,
          shiharaisakiKb: this.shiharaisakiKb,
          soshikiCd: this.soshikiCd,
          gyoshuCd: this.gyoshuCd,
          mukoUmuFlg: this.mukoUmuFlg,
          tokenCheckFlg: this.tokenCheckFlg,
        },
      });
      if (!res.data.responseData || res.data.responseData.length === 0) {
        this.shiiresakiRyakuMei = '';
        this.isNoData = true;
        this.errors = noDataError();

        this.callbackOk && this.callbackOk({ shiiresakiCd: this.shiiresakiCd });
        return;
      }
      this.errors = clearNoDataError();
      const { shiiresakiRyakuMei } = res.data.responseData[0];
      this.shiiresakiRyakuMei = shiiresakiRyakuMei;
      this.callbackOk && this.callbackOk(res.data.responseData[0]);
      this.isNoData = false;
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [shiiresakiCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.shiiresakiCd': {
      async handler(newValue) {
        if (newValue === undefined || +newValue === +this.shiiresakiCd) return;
        this.shiiresakiCd = +newValue;
        if (newValue) {
          await this.getShiiresakiItem();
        } else {
          this.shiiresakiRyakuMei = '';
          this.errors = clearNoDataError();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    this.mounted = true;
  },
});
